import { ECONOMY, QUANTUM, DELUXE, STANDARD, CORE, CHOICE } from 'core/constants/products'
import isPlanType from 'utils/pivot/plan/isPlanType'

const CLIC_TYPES = [ECONOMY, QUANTUM, DELUXE, STANDARD, CORE, CHOICE]

function isClicPlan(plan: Plan): boolean {
  return CLIC_TYPES.some(type => isPlanType(plan, type))
}

export default isClicPlan
